import { IFetchDataWithFeature } from "context/model/ContextModel";
import isEmpty from "lodash/isEmpty";
import { productCache } from "utils/cache/productCache";
import { CacheKeyEnum } from "utils/enums/CacheKeyEnum";
import { AppBasedServiceInjection } from "utils/serviceRepo/ServiceRepo";

export class FeatureFormat {
  static findFeature = (path: string) => {
    let cachedFeature = productCache?.getCache(CacheKeyEnum.internalFeature);
    if (cachedFeature?.some((item) => path?.includes(item?.path))) {
      return true;
    } else {
      return false;
    }
  };

  static validateFeature = (key: string) => {
    let cachedCapabilities = productCache?.getCache(CacheKeyEnum.capabilities);
    return cachedCapabilities?.find((item: string) => item?.includes(key));
  };

  static fetchFilterList = async <R extends Object, P extends Object>(
    props: IFetchDataWithFeature<R, P>,
  ) => {
    const {
      dataState,
      path,
      savedKey,
      isForceRefresh,
      params,
      isNeedFeature = false,
      needExpired = true,
      onError,
    } = props;
    try {
      if (isNeedFeature && !findFeature(path)) {
        !!savedKey && productCache?.resetCache(savedKey);
        return undefined;
      } else {
        if (!isEmpty(productCache?.getCache(savedKey)) && !isForceRefresh) {
          dataState(productCache?.getCache(savedKey));
          return productCache?.getCache(savedKey);
        } else {
          const repo = AppBasedServiceInjection.getFeatureRepo();
          const res = await repo.getPathWithFeature<P, R>(path, params);
          if (res?.data) {
            dataState(res?.data);
            if (!!savedKey) {
              productCache.saveCache({
                key: savedKey,
                product: res?.data,
                needExpired,
                timeExpired: 10800,
              });
            }
          }
          return res?.data;
        }
      }
    } catch (error) {
      console.error(error);
      !!onError && onError(error);
    }
  };
}

export const { findFeature, fetchFilterList } = FeatureFormat;
